var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"mc-video-alert__video-item-state video-upload"},[_c('div',{staticClass:"mc-video-alert__content-wrapper"},[_c('span',{staticClass:"upload-process"},[_vm._v(" "+_vm._s(_vm.$t('global.action.uploadProcess'))+" ...")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }